import { NavLink } from "react-router-dom";
import styled from "styled-components";

export const AvatarWrapper = styled.div`
  display: flex;
  align-items: center;
  cursor: pointer;

  div {
    margin-left: 16px;
    color: #5c5c5c;
    display: flex;
    flex-direction: column;
    gap: 5px;

    h3 {
      font-weight: 700;
      font-size: 18px;
    }

    p {
      font-weight: 400;
      font-size: 14px;
    }
  }
`;

export const StyledNavLink = styled(NavLink)`
  color: #8a8a8a;
  font-weight: bold;
  font-size: 16px;
`;

export const IconWrapper = styled.div`
  background: #efefef;
  width: 44px;
  height: 44px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 8px;
`;

export const Header = styled.div`
  position: sticky;
  top: 0;
  left: 0;
  width: 100%;
  padding: 0 30px;
  z-index: 1;
  box-shadow: 0 4px 30px -4px rgba(0, 51, 90, 0.1);
  background: #fff;
  display: flex;
  align-content: center;
  align-items: center;
  justify-content: space-between;
  z-index: 80;
  display: flex;
`;

export const Nav = styled.ul`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;

  & > div {
    display: flex;
  }
`;

export const Badge = styled.div`
  padding: 2%;
  position: absolute;
  top: 1%;
  left: 40%;
  border-radius: 20%;
  height: 21px;
  text-align: center;
  color: white;
  font-size: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
`;

Nav.Item = styled.li`
  position: relative;
  display: inline-block;
  margin: 0 8px;

  &:first-child {
    margin-left: 0;
  }

  &:last-child {
    margin-right: 0;
  }

  > a {
    color: ${({ theme }) => theme.colors.dark};
    display: flex;
    align-items: center;
    font-size: 12px;
    padding: 18px 0;
    font-weight: 500;
    text-transform: uppercase;

    svg {
      width: 24px;
      height: 24px;
      display: block;
      fill: ${({ theme }) => theme.colors.dark};
    }

    &:hover,
    &.active {
      color: ${({ theme }) => theme.colors.default};

      svg {
        fill: ${({ theme }) => theme.colors.default};
      }
    }
  }
`;
